import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

@Component({
    templateUrl: 'withdrawDetail.html',
    selector: 'withdraw-detail-page',
})
export class WithdrawDetailPage {
    public loginname: string = '';
    public id: string = '';
    public amount: number;
    public applyTime: string = '';
    public note: string = '';
    public status: string = '';

    constructor(private navParams: NavParams, private nav: NavController) {
        let params = navParams.data.paramItem;
        this.loginname = params.loginname;
        this.id = params.id;
        this.amount = params.amount;
        this.applyTime = params.applytime;
        this.note = params.remark;
        this.status = params.statusname;
    }
}



// WEBPACK FOOTER //
// ./src/pages/withdrawDetail/withdrawDetail.ts